export const ProjectColors = {
    Red: '#ff4531',
    DarkRed: '#a51101',
    Orange: '#fe9825',
    DarkOrange: '#e68612',
    Yellow: '#f2db27',
    LightYellow: '#f2e583',
    Pink: '#ee42a9',
    LightPink: '#ffadfb',
    Green: '#309c27',
    LightGreen: '#46bd4c',
    LighterGreen: '#82f578',
    SteelBlue: '#6b62fe',
    Blue: '#3881f5',
    LightBlue: '#73a7fa',
    Aqua: '#1f95f5',
    DarkTeal: '#00a89d',
    Teal: '#24dae3',
    LightTeal: '#8df2f7',
    Brown: '#ab6700',
    LightBrown: '#e3b064',
    LightGray: '#d4d4d4',
    Purple: '#8403fc',
    LightPurple: '#c485ff',
    Gray: '#bababa'
}